import { XCircleIcon } from '@heroicons/react/outline';
import { PlusIcon } from 'components/icons';
import { useAppDispatch } from 'store';
import {
  addFilterClause,
  GroupedFilterClause,
  MainOperatorEnum,
  removeFilterClause,
  selectMainOperator,
} from 'store/composableFiltersSlice';
import { ClausePrefix } from './ClausePrefix';
import { NestedClause } from './NestedClause';

interface FilterClauseProps {
  data: GroupedFilterClause;
  index: number;
  noPrefix?: boolean;
}

export const NestedFilterClause = ({
  data,
  index,
  noPrefix,
}: FilterClauseProps) => {
  const dispatch = useAppDispatch();

  const handleSelectMainOperator = (selectedOption: {
    value: string;
    label: string;
  }) => {
    dispatch(
      selectMainOperator({
        type: 'singleFilterClause',
        value: selectedOption?.value as MainOperatorEnum,
      })
    );
  };

  const handleDelete = (childrenIndex?: number) => {
    if (childrenIndex) {
      dispatch(
        removeFilterClause({
          type: 'groupedFilterClause',
          index: childrenIndex,
          parentIndex: index,
        })
      );
    } else {
      dispatch(
        removeFilterClause({
          type: 'singleFilterClause',
          index: index,
        })
      );
    }
  };

  return (
    <div className="flex items-start justify-center space-x-2">
      <div className="w-20 ">
        <ClausePrefix
          index={index}
          handleSelectOperator={handleSelectMainOperator}
        />
      </div>
      <div className="w-full p-2 mr-2 space-y-3 border rounded-lg">
        {data.conditions?.map((item, childrenIndex) => (
          <div
            className="flex items-start justify-start space-x-2"
            key={childrenIndex}
          >
            <NestedClause
              data={item}
              parentIndex={index}
              childrenIndex={childrenIndex}
              noPrefix={noPrefix}
            />
            <button
              className="ml-3 place-self-center"
              onClick={() => handleDelete(childrenIndex)}
            >
              <XCircleIcon className="w-5 h-5 text-gray-500" />
            </button>
          </div>
        ))}

        <div>
          <div className="mt-5">
            <button
              className="flex items-center space-x-2 text-segments-link"
              onClick={() => {
                dispatch(
                  addFilterClause({
                    type: 'groupedFilterClause',
                    parentIndex: index,
                  })
                );
              }}
            >
              <PlusIcon className="w-5 h-5 " />
              <p>Add a filter</p>
            </button>
          </div>
        </div>
      </div>

      <button className="mt-2" onClick={() => handleDelete()}>
        <XCircleIcon className="w-5 h-5 text-gray-500" />
      </button>
    </div>
  );
};
